import {
    DATA_AUTH_ATTTIBUTE_NAME,
    ORIGINALSRC_ATTTIBUTE_NAME,
    SHASH_ATTTIBUTE_NAME,
} from '../utils/constants';

export default function isSafeLink(element: HTMLElement) {
    return (
        element.hasAttribute(ORIGINALSRC_ATTTIBUTE_NAME) &&
        element.hasAttribute(SHASH_ATTTIBUTE_NAME) &&
        element.hasAttribute(DATA_AUTH_ATTTIBUTE_NAME)
    );
}
